/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoManagerTerminateSessionRequest model module.
 * @module model/ManagerControllerDtoManagerTerminateSessionRequest
 * @version 1.0
 */
class ManagerControllerDtoManagerTerminateSessionRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerTerminateSessionRequest</code>.
     * @alias module:model/ManagerControllerDtoManagerTerminateSessionRequest
     */
    constructor() { 
        
        ManagerControllerDtoManagerTerminateSessionRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerTerminateSessionRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerTerminateSessionRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerTerminateSessionRequest} The populated <code>ManagerControllerDtoManagerTerminateSessionRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerTerminateSessionRequest();

            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerTerminateSessionRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerTerminateSessionRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} managerNo
 */
ManagerControllerDtoManagerTerminateSessionRequest.prototype['managerNo'] = undefined;






export default ManagerControllerDtoManagerTerminateSessionRequest;

